import { Component, OnInit, ViewChild } from "@angular/core";
import { TrailerService } from "../shared/trailer.service";
import { Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { SelectItem } from "primeng/api";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-trailerlist",
  templateUrl: "./trailerlist.component.html",
  styleUrls: ["./trailerlist.component.css"],
})
export class TrailerlistComponent implements OnInit {
  colsTrailers: any = [];
  errorMsg: any;
  allRecord: any = [];

  statusOptions: SelectItem[] = [
    { label: "ALL", value: null },
    { label: "ACTIVE", value: "Active" },
    { label: "INACTIVE", value: "Inactive" },
  ];

  constructor(
    private _trailerlist: TrailerService,
    private router: Router,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit() {
    this.colsTrailers = [
      { field: "trailerNo", header: "Trailer Number", width: 130 },
      { field: "trailerType", header: "Trailer Type", width: 120 },
      { field: "equipmentCode", header: "Equipment Code", width: 135 },
      { field: "terminalLocation", header: "Terminal Location", width: 200 },
      { field: "currentLocation", header: "Current Location", width: 180 },
      { field: "fleetillaUpdated", header: "Location Updated", width: 150 },
      { field: "active", header: "Status", width: 100, type: "boolean" },
    ];
    this._trailerlist.findAndFilter().subscribe(
      (resTrailerData) => {
        this.allRecord = resTrailerData;
      },
      (resTrailerDataError) => {
        this.errorMsg = resTrailerDataError;
      }
    );
  }

  viewDetail(trailer: any) {
    if (this.featureFlagsService.isEnabled('useNewTrailerPages')) {
      this.router.navigate(["/trailers/", trailer.uuid]);
    } else {
      this.router.navigate(["/trailerinfo/", trailer.uuid]);
    }
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this._AuthService.hasPermission(permission);
  }

  getCurrentLocation(trailer: any): string {
    if (!trailer.currentLocationCity && !trailer.currentLocationState) {
      return "-";
    }
    return [trailer.currentLocationCity, trailer.currentLocationState].filter(Boolean).join(", ");
  }

  getFleetillaUpdated(trailer: any): string {
    const raw = trailer.fleetillaLocationUpdatedUtc;
    if (!raw) return "-";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "-";

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);

    if (diffHours < 1) {
      return "<1h ago";
    } else if (diffHours < 24) {
      return `${diffHours}h ago`;
    } else if (diffDays === 1) {
      return "1d ago";
    } else {
      return `${diffDays}d ago`;
    }
  }

  getFleetillaUpdatedTooltip(trailer: any): string {
    const raw = trailer.fleetillaLocationUpdatedUtc;
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleString();
  }

  isFleetillaStale(trailer: any): boolean {
    const raw = trailer.fleetillaLocationUpdatedUtc;
    if (!raw) return false;
    const d = new Date(raw);
    if (isNaN(d.getTime())) return false;

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffHours = diffMs / (1000 * 60 * 60);

    return diffHours > 48;
  }
}
